import { render, staticRenderFns } from "./NormalTimeStudy.vue?vue&type=template&id=189cb678&scoped=true&"
import script from "./NormalTimeStudy.vue?vue&type=script&lang=js&"
export * from "./NormalTimeStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cb678",
  null
  
)

export default component.exports